import { render, staticRenderFns } from "./m-four-params.vue?vue&type=template&id=4b0ca23f&scoped=true&"
import script from "./m-four-params.vue?vue&type=script&lang=ts&"
export * from "./m-four-params.vue?vue&type=script&lang=ts&"
import style0 from "./m-four-params.vue?vue&type=style&index=0&id=4b0ca23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ca23f",
  null
  
)

export default component.exports